export const TAG_FILE_WORKSTREAM_LABEL = 'Add/Edit Tagged Workstream';
export const EMAIL_SUFFIX = process.env.INBOX_DOMAIN || 'app.cloudcfo.ph';
export const FALLBACK_EMAIL = 'N/A';

// Route paths consumed via `.path` only (dashboard link, settings deep-link).
interface ProjectPageRoute {
  path: string;
}

// Partial table (not a mirror of projectDetails.js's route switch) — consumers
// read `.path` only. No `reports` entry on purpose: importing ReportsWorkspace
// here would pull the workspace bundle into this shared chunk (projectDetails.js
// lazy-loads it in its own chunk instead).
export const PROJECT_PAGE_ROUTES: Record<string, ProjectPageRoute> = {
  project_dashboard: { path: '/projects/:projectId' },
  project_settings: { path: '/projects/:projectId/settings/:settingsRoute' },
};
